import React from 'react';
import s from './MobileFiltersModal.scss';
import classNames from 'classnames';
import {Filters} from '../../../../../gallery/components/Filters/Filters';

import {withGlobals} from '../../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../../gallery/galleryGlobalStrategy';
import FocusTrap from 'focus-trap-react';

export interface IMobileFiltersModal extends IGalleryGlobalProps {
  className: string;
  clearFilters: Function;
  closeModal: Function;
  isOpen: boolean;
  shouldShowClearFilters: boolean;
  modalRef: React.RefObject<HTMLDivElement>;
  filtersBtnRef: React.RefObject<HTMLButtonElement>;
  modalHeaderId: string;
  combineFiltersAndSort?: boolean;
}

class MobileFiltersModalComp extends React.Component<IMobileFiltersModal> {
  public state = {
    activeTrap: this.props.isOpen,
  };

  public componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({activeTrap: this.props.isOpen});
      this.updateInertAttribute();
    }
  }

  public componentDidMount(): void {
    this.updateInertAttribute();
  }

  public updateInertAttribute() {
    const modalDiv = this.props.modalRef.current;
    if (this.props.isOpen) {
      modalDiv?.removeAttribute('inert');
    } else {
      modalDiv?.setAttribute('inert', '');
    }
  }

  public render() {
    const {isOpen, shouldShowClearFilters, clearFilters, closeModal, combineFiltersAndSort, modalHeaderId, modalRef} =
      this.props;
    const {isPreviewMode} = this.props.globals;

    const classnames = classNames({
      [s.modal]: true,
      [s.open]: isOpen,
      [s.preview]: isPreviewMode,
    });

    const filtersModal = (
      <div
        className={classnames}
        data-hook="mobile-filters-modal"
        tabIndex={-1}
        role={'dialog'}
        aria-labelledby={modalHeaderId}
        aria-modal={isOpen}
        ref={modalRef}>
        <Filters
          closeMobileFiltersModal={() => closeModal()}
          shouldShowClearFiltersButton={shouldShowClearFilters}
          clearFilters={clearFilters}
          modalHeaderId={modalHeaderId}
          combineFiltersAndSort={combineFiltersAndSort}
        />
      </div>
    );

    return (
      <FocusTrap
        active={this.state.activeTrap}
        focusTrapOptions={{
          initialFocus: /* istanbul ignore next reason: tested in sled */ () => this.props.modalRef.current,
          fallbackFocus: () => this.props.modalRef.current,
          onDeactivate: () => closeModal(),
          returnFocusOnDeactivate: true,
          setReturnFocus: () => this.props.filtersBtnRef.current,
        }}>
        {filtersModal}
      </FocusTrap>
    );
  }
}

export const MobileFiltersModal = withGlobals(MobileFiltersModalComp);
